import {
  ComponentService,
  DataTransmissionService,
  DbCommonColumnName,
  FetchListResponseDataFormat,
  LabelAndValue,
  MessageService,
  ResponseDataModel,
  ShowDefaultDialogService,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';

/**
 * MSupplierに関するユーティリティ
 */
export namespace MSupplierUtility {
  /**
   * 委託先のコンボボックスのラベルと値（選択肢）を取得する
   */
  export async function fetchMSupplierLabelAndValue(): Promise<LabelAndValue[]> {
    let labelAndValueList: LabelAndValue[] = [];
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    return new Promise<LabelAndValue[]>(async (resolve, reject) => {
      try {
        // 指定したレコードを取得する
        const callBack = (response: ResponseDataModel) => {
          if (!response.isCompleted) {
            resolve(labelAndValueList);
          }
          fetchData.setParam(response);

          fetchData.dataList
            .filter((data) => data['Status'] === 'Verified')
            .forEach((data) => {
              labelAndValueList.push({
                label: data['SupplierName'] + ' ' + data['Person'],
                value: data['TicketKey'],
              });
            });
          if (fetchData.lastPage) {
            resolve(labelAndValueList);
          }
        };

        // 検索条件は委託先の全てのレコードを取得する
        const fetchData = new FetchListResponseDataFormat();
        let condition: any = { MaxCountInPage: 100 };
        while (!fetchData.lastPage) {
          await dtService.fetchList(ViewType.List, 'MSupplier', condition, callBack, false, null);
          condition['NextPaginationStartKey'] = fetchData.nextPaginationStartKey;
        }
      } catch (error) {
        return resolve(labelAndValueList);
      }
    });
  }

  /**
   * MSupplierのレコードを取得する
   * @param mSupplierTicketKey
   * @returns
   */
  export async function getMSupplier(mSupplierTicketKey: string): Promise<any> {
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    // 検索条件は委託先の全てのレコードを取得する
    const condition = {
      [DbCommonColumnName.TICKET_TYPE]: 'MSupplier',
      [DbCommonColumnName.TICKET_KEY]: mSupplierTicketKey,
    };

    return new Promise<any>((resolve, reject) => {
      try {
        // 指定したレコードを取得する
        const callBack = (response: ResponseDataModel) => {
          if (!response.isCompleted) {
            resolve(null);
          }
          resolve(response.data);
        };

        dtService.fetchRecord(ViewType.Edit, 'MSupplier', condition, callBack, false, null, false);
      } catch (error) {
        return resolve(null);
      }
    });
  }
}
